import { GetUrlQueryType } from '../graphql/types';

const cache = new Map<string, [GetUrlQueryType, number]>();

const has = (key: string) => {
  return cache.has(key);
};
const set = (key: string, value: GetUrlQueryType) => {
  return cache.set(key, [value, Date.now()]);
};

const get = (key: string) => {
  return cache.get(key)?.[0];
};

const deleteKey = (key: string) => {
  return cache.delete(key);
};

const clear = () => {
  return cache.clear();
};

const isExpired = (key: string, seconds: number) => {
  const val = cache.get(key);
  if (val) {
    const [, timestamp] = val;
    return (Date.now() - timestamp) / 1000 > seconds;
  }
  return true;
};

export { has, set, get, deleteKey, clear, isExpired };
